import { Text } from '@consumidor-positivo/aurora';

import { MMChance } from '../../../../types';

import { dataChances } from '../data';

type ChanceTagProps = {
  chance?: MMChance;
};
export const ChanceTag = ({ chance = 'low' }: ChanceTagProps) => {
  const tagVariant = dataChances[chance];

  return (
    <div className={`mm-tag mm-tag--${tagVariant.status}`}>
      <Text as="p" variant="body-small" weight="semibold" className="mm-tag__text">
        {tagVariant.status === 'success' && (
          <span role="img" aria-label="Emoji de fogo">
            🔥
          </span>
        )}
        {tagVariant.text}
      </Text>
    </div>
  );
};
